// useArgumentAgent.js
import { useQuery } from "@tanstack/react-query";
import { checkCategoryAgent } from "../../api/agents/agentsApi";
import { useUserStore } from "../../Context/store";

export const useCategoryAgent = (motion, category, image, enabled) => {
  const { user: loggedInUser } = useUserStore();
  return useQuery({
    queryKey: ["category-validate", motion, category, image],
    queryFn: async () => {
      return await checkCategoryAgent({ motion, category, img_url: image, user_id: loggedInUser?.userId, sessionid: loggedInUser?.sessionId });
    },
    select: (data) => data.data,
    enabled: !!motion && !!category && !!loggedInUser && !!enabled,
  });
};
